import { Currency } from './tickets'

export interface PlanPrice {
  id: number
  amount: number
  currency: Currency
}

export interface Plan {
  id: number
  name: string | Record<string, string>
  description: string | Record<string, string>
  period: number // period in months
  prices: PlanPrice[]
  features: string[]
}

export interface Subscription {
  id: number
  status: number
  start_at: string
  ends_at: string
  cancelled_at: string | null
  next_charge_at: string | null
  subscription_plan: Plan
}

export enum SubscriptionTicketStatus {
  Created = 0,
  Activated = 1,
}

export interface TicketData {
  id: number
  name: string
  subtitle: string | null
  paid: boolean
  upgradable: boolean
  event_id: number
}

// tickets that user gets after buying subscription
export interface SubscriptionTicket {
  id: number
  event_id: number
  status: SubscriptionTicketStatus
  subscription_id: number
  ticket_id: number
  user_id: number
}
